import { Component, Input } from "@angular/core";
import { AuthService } from "src/app/core/service/auth.service";
import { LeaderboardDTO } from "src/app/data/schema/Gamification/Leaderboard/LeaderboardDTO";

@Component({
    selector: "app-podium-avatar",
    templateUrl: "./podium-avatar.component.html",
    styleUrls: ["./podium-avatar.component.scss"]
})
export class PodiumAvatarComponent {
    @Input() leader: LeaderboardDTO;

    loggedUserId: string;
    loggedUserGroupIds: string[];

    constructor(private authService: AuthService) {
        this.loggedUserId = this.authService.getClaimsUserId();
        this.loggedUserGroupIds = this.authService.getClaimsGroupIds();
    }

    userIsInTheGroup(id: string): boolean {
        if (!id) return false;
        return this.loggedUserGroupIds?.includes(id);
    }
}
